import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';

// Import pages
import SplashScreen from './pages/splash-screen';
import LoginPage from './pages/login';
import DinnerPlanningPage from './pages/dinner-planning';
import DishLibraryPage from './pages/dish-library';
import GuestManagementPage from './pages/guest-management';
import AIAssistantPage from './pages/ai-assistant';
import NotFound from './pages/NotFound';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/splash-screen" element={<SplashScreen />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<DinnerPlanningPage />} />
          <Route path="/dinner-planning" element={<DinnerPlanningPage />} />
          <Route path="/dish-library" element={<DishLibraryPage />} />
          <Route path="/guest-management" element={<GuestManagementPage />} />
          <Route path="/ai-assistant" element={<AIAssistantPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;